import React, { useEffect } from 'react'
import commonStyles from "../../AddPayerCommonStyles.styles"
import Heading from '../../../../../components/heading/Heading'
import { HEADING } from '../../../../../components/heading/constants/constants'
import TextInput from '../../../../../components/input/textinput/TextInput'
import styles from "./GetBasicInfo.styles"
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setBasicInformation } from '../../AddPayerSlice'
import { PAYER_TYPE_TITLE } from '../getpayertype/constants'
import Payer from '../../../../../../libs/utility/Payer'
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator'
import ErrorsList from '../../../../../components/input/errorslist/ErrorsList'
import { VALIDATE_NAME_REGEX } from '../../../../../../libs/utility/constants'
import { PAYER_BUSINESS_FIELD_NAME, PAYER_PHONE_NUM_FIELD_NAME, PAYER_SUFFIX_OPTIONS } from '../../constant'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import General from '../../../../../../libs/utility/General'

export default function GetBasicInfo({ payerLabel = "Payer" }) {

    const { basicInfo, PayerType } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setBasicInformation({ [name]: { value, errors, rules } }));
        }
        else {
            dispatch(setBasicInformation({ [name]: { value } }));
        }
    };

    const validateData = (event, rules) => {
        General.validateInputWithRegex(event, () => onChangehandler(event, rules))
    }

    const { tinTooltip, tinPlaceholder, tinValue, tinRules, showNames, tinDisabled } = Payer.getTINProps(PayerType, basicInfo.TIN?.value);

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>Can you tell us more about this {payerLabel}?</Heading>
                    <p>This information is required by the IRS. Let's fill this out quickly and
                        move on.</p>
                </div>

                <div style={commonStyles.formContainer}>
                    <div>
                        <div style={styles.payersNameContainer}>

                            {showNames &&
                                (<>
                                    <TextInput
                                        name="PayerFirstName"
                                        label={`${payerLabel}'s name`}
                                        placeHolder='First Name'
                                        value={basicInfo.PayerFirstName.value}
                                        onChangeCb={onChangehandler}
                                        rules={basicInfo.PayerFirstName?.rules}
                                        formSubmitted={basicInfo.allRequiredFieldsTouched}
                                        errors={basicInfo.PayerFirstName?.errors}
                                    />
                                    <div style={styles.payersMiddleNameContainer}>
                                        <TextInput
                                            name="PayerMiddleName"
                                            label='Middle Name'
                                            placeHolder='Middle Name'
                                            value={basicInfo.PayerMiddleName.value}
                                            rules={basicInfo.PayerMiddleName.rules}
                                            onChangeCb={onChangehandler}
                                            formSubmitted={basicInfo.allRequiredFieldsTouched}
                                            errors={basicInfo.PayerMiddleName?.errors}
                                        />
                                    </div>
                                </>)}

                            {showNames && <TextInput
                                label={showNames ? "Last Name" : "Business Name"}
                                name={PAYER_BUSINESS_FIELD_NAME}
                                placeHolder={showNames ? "Last Name" : "Enter business name"}
                                value={basicInfo.PayerLastName.value}
                                onChangeCb={onChangehandler}
                                rules={basicInfo.PayerLastName?.rules}
                                formSubmitted={basicInfo.allRequiredFieldsTouched}
                                errors={basicInfo.PayerLastName?.errors}
                            />}

                        </div>
                    </div>
                    <div style={styles.payerFieldsContainer}>
                        <div style={styles.payerBatch1Container}>
                            <TextInput
                                name="TIN"
                                type="text"
                                labelWTooltip={tinTooltip}
                                placeHolder={tinPlaceholder}
                                value={tinValue}
                                onChangeCb={onChangehandler}
                                rules={{ ...basicInfo.TIN?.rules, ...tinRules }}
                                errors={basicInfo.TIN.errors}
                                formSubmitted={basicInfo.allRequiredFieldsTouched}
                                disabled={tinDisabled}
                                tabIndex="2"
                            />
                        </div>
                        <div style={styles.payerBatch2Container}>
                            {!showNames && <TextInput
                                label={showNames ? "Last Name" : "Business Name"}
                                name={PAYER_BUSINESS_FIELD_NAME}
                                placeHolder={showNames ? "Last Name" : "Enter business name"}
                                value={basicInfo.PayerLastName.value}
                                onChangeCb={onChangehandler}
                                rules={basicInfo.PayerLastName?.rules}
                                formSubmitted={basicInfo.allRequiredFieldsTouched}
                                errors={basicInfo.PayerLastName?.errors}
                            />}

                            {PayerType === PAYER_TYPE_TITLE.INDIVIDUAL ?
                                <SelectDropdown
                                    label="Suffix"
                                    name="PayerSuffix"
                                    value={{ label: basicInfo.PayerSuffix.label, value: basicInfo.PayerSuffix.value }}
                                    onSelectCb={(name, selectedOption) => dispatch(setBasicInformation({ [name]: selectedOption }))}
                                    options={PAYER_SUFFIX_OPTIONS}
                                    tabIndex="1"
                                /> : null}
                        </div>
                    </div>
                    <div style={styles.payerFieldsContainer}>
                        <div style={styles.payerBatch1Container}>
                            <TextInput
                                name="PayerEmail"
                                type="email"
                                label="Email Address"
                                placeHolder='abc@example.com'
                                value={basicInfo.PayerEmail?.value}
                                onChangeCb={onChangehandler}
                                rules={basicInfo.PayerEmail?.rules}
                                errors={basicInfo.PayerEmail.errors}
                                formSubmitted={basicInfo.allRequiredFieldsTouched}
                                tabIndex="3"
                            />
                        </div>
                        <div style={styles.payerBatch2Container}>
                            <TextInput
                                label="Phone Number"
                                name={PAYER_PHONE_NUM_FIELD_NAME}
                                placeHolder="(201) 555-0123"
                                type="text"
                                value={basicInfo.PayerPhNo?.value}
                                onChangeCb={validateData}
                                rules={basicInfo.PayerPhNo?.rules}
                                errors={basicInfo.PayerPhNo.errors}
                                formSubmitted={basicInfo.allRequiredFieldsTouched}
                                tabIndex="4"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}